<template>
  <div class="main-cart__summary cart-summary critical-component-clear">
    <div class="cart-summary__title-container">
      <span
        class="cart-summary__title"
        v-text="`${$string('cart.summary.subtotal_label')}:`"
      />
      <span
        class="cart-summary__title"
        v-text="`${$formatMoney(cart.total_price, format)}`"
      />
    </div>

    <div class="cart-summary__title-container">
      <span
        class="cart-summary__title"
        v-text="$string('cart.summary.shipping_label')"
      />
      <span
        class="cart-summary__title cart-summary__title--small"
        v-text="$string('cart.summary.shipping_taxes_label')"
      />
    </div>

    <div class="cart-summary__title-container cart-summary__title-container--spaced">
      <span
        class="cart-summary__title"
        v-text="`${$string('cart.summary.total_label')}:`"
      />
      <span
        class="cart-summary__title"
        v-text="`${$formatMoney(cart.total_price, format)}`"
      />
    </div>

    <p
      v-if="savings"
      class="cart-summary__save text-heading-s"
      v-text="`${$string('cart.summary.save_label')}: ${$formatMoney(savings, format)}`"
    />

    <btn
      class="cart-summary__submit"
      :label="$string('cart.checkout')"
      modifiers="block"
      name="checkout"
      type="submit"
    />

    <p
      class="cart-summary__discount text-body-s"
      v-text="$string('cart.summary.discount_label')"
    />
  </div>
</template>

<script>

/**
 * Vue: Cart summary (main-cart)
 * -----------------------------------------------------------------------------
 * Summary of cart metrics with checkout CTA.
 *
 *
 */
import { mapState } from 'vuex'

import Btn from '~global/btn/btn'
import checkoutAccordion from '~/checkout/checkout-accordion'

export default {
  name: 'CartSummary',

  components: {
    Btn,
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
    }),

    /**
     * Compute money saved.
     * @returns {Number}
     */
    savings() {
      let savings = 0

      this.cart.items.forEach((item) => {
        if (!item.compare_at_line_price) {
          return
        }

        const difference = item.compare_at_line_price - item.final_line_price

        if (difference <= 0) {
          return
        }

        savings += difference
      })

      return savings
    },

    // return money format
    format() {
      return window.cnvs.store.moneyFormat
    },
  },

  mounted() {
    checkoutAccordion().init()
  },
}
</script>

<style lang="scss">
@import './cart-summary';
</style>
